import React from "react";
import styled from "styled-components";
import { Card, Row, Col, Tag, Tooltip, Badge, Button, Space } from "antd";
import {
  MessageOutlined,
  CarOutlined,
  ReloadOutlined,
} from "@ant-design/icons";

const StatusCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .ant-card-head {
    background: #005249;
    color: white;
    border-radius: 12px 12px 0 0;
  }

  .ant-card-head-title {
    color: white;
    font-weight: 600;
  }
`;

const StatusItem = styled.div`
  text-align: center;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }
`;

const RefreshButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
`;

const PlatformStatusCard = ({
  platformStatus,
  onRefresh,
  getPlatformStatusTooltip,
}) => {
  return (
    <StatusCard
      title="Platform Status"
      extra={
        <Space size="small" align="center">
          <RefreshButton
            type="text"
            size="small"
            icon={<ReloadOutlined />}
            onClick={onRefresh}
            title="Refresh Platform Status"
          />
          <Tooltip
            title={
              <div style={{ maxWidth: "350px" }}>
                <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                  System Status Overview
                </div>
                <div style={{ marginBottom: "8px" }}>
                  <strong>WhatsApp:</strong>{" "}
                  {platformStatus?.whatsapp === "online"
                    ? "✅ Online"
                    : "❌ Offline"}
                </div>
                <div style={{ marginBottom: "8px" }}>
                  <strong>Fleet:</strong>{" "}
                  {platformStatus?.fleet === "operational"
                    ? "✅ Operational"
                    : "❌ Issues"}
                </div>
                {platformStatus?.details?.lastChecked && (
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#999",
                      marginTop: "8px",
                    }}
                  >
                    Last checked:{" "}
                    {new Date(
                      platformStatus.details.lastChecked
                    ).toLocaleString()}
                  </div>
                )}
              </div>
            }
            placement="bottom"
          >
            <Badge
              status={
                platformStatus?.overall === "healthy" ? "success" : "error"
              }
              text={
                platformStatus?.overall === "healthy"
                  ? "All Systems Operational"
                  : "Issues Detected"
              }
            />
          </Tooltip>
        </Space>
      }
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Tooltip
            title={
              getPlatformStatusTooltip(
                "whatsapp",
                platformStatus?.whatsapp,
                platformStatus?.details
              ).content
            }
            placement="top"
          >
            <StatusItem>
              <MessageOutlined style={{ fontSize: 24, color: "#005249" }} />
              <div>WhatsApp</div>
              <Tag
                color={
                  platformStatus?.whatsapp === "online" ? "success" : "error"
                }
              >
                {platformStatus?.whatsapp === "online" ? "Online" : "Offline"}
              </Tag>
            </StatusItem>
          </Tooltip>
        </Col>
        <Col span={12}>
          <Tooltip
            title={
              getPlatformStatusTooltip(
                "fleet",
                platformStatus?.fleet,
                platformStatus?.details
              ).content
            }
            placement="top"
          >
            <StatusItem>
              <CarOutlined style={{ fontSize: 24, color: "#005249" }} />
              <div>Fleet</div>
              <Tag
                color={
                  platformStatus?.fleet === "operational" ? "success" : "error"
                }
              >
                {platformStatus?.fleet === "operational"
                  ? "Operational"
                  : "Issues"}
              </Tag>
            </StatusItem>
          </Tooltip>
        </Col>
      </Row>
    </StatusCard>
  );
};

export default PlatformStatusCard;
